import { atom } from 'jotai';

import { PopupVideoImagenTO } from '@/types/popupImageVideo';

export type DataPopup = {
  seMostro: boolean;
  idUsuarioDT: number;
  fecha: string;
  popup: PopupVideoImagenTO;
};

export const popupsImageVideoAtom = atom<DataPopup[]>([]);

export function buildDataPopup(
  idUsuarioDT: number,
  fecha: string,
  popup: PopupVideoImagenTO
): DataPopup {
  return {
    seMostro: false,
    idUsuarioDT,
    fecha,
    popup,
  };
}

export function findDataPopup(
  popups: DataPopup[],
  idUsuarioDT: number,
  fecha: string,
  idPP: number
): DataPopup | undefined {
  return popups.find(
    (popup) =>
      popup.idUsuarioDT === idUsuarioDT &&
      popup.fecha === fecha &&
      popup.popup.id === idPP
  );
}

export function mergeDataPopup(
  popups: DataPopup[],
  dataPopup: DataPopup
): DataPopup[] {
  const clonedArray = [...popups.map((popup) => ({ ...popup }))];
  const toReplace = findDataPopup(
    clonedArray,
    dataPopup.idUsuarioDT,
    dataPopup.fecha,
    dataPopup.popup.id
  );
  if (toReplace) {
    toReplace.seMostro = dataPopup.seMostro;
  } else {
    clonedArray.push(dataPopup);
  }
  return clonedArray;
}

export function insertPopupStore(
  dataPopup: DataPopup,
  popupsArray: DataPopup[],
  setPopupsArray: (popupsArray: DataPopup[]) => void
) {
  const clonedArray = [...popupsArray.map((popup) => ({ ...popup }))];
  const found = findDataPopup(
    clonedArray,
    dataPopup.idUsuarioDT,
    dataPopup.fecha,
    dataPopup.popup.id
  );
  if (!found) {
    clonedArray.push(dataPopup);
    setPopupsArray(clonedArray);
  }
}
